<template>
  <el-dialog
    title="批量审单"
    :visible.sync="visible"
    width="560px"
    append-to-body=""
    @closed="handleClosed">
    <el-steps
      v-if="orderInfo.warehouseList.length > 1"
      align-center
      :active="active"
      finish-status="success">
      <el-step
        v-for="(sitem,index) in orderInfo.warehouseList"
        :key="index"
        :title="sitem.departmentId | departmentName()"></el-step>
    </el-steps>
    <el-form
      :ref="'ruleForm'"
      style="margin-top:12px;"
      :rules="rules"
      label-width="100px"
      :model="item">
      <el-form-item label="当前部门:"> {{ item.departmentId | departmentName() }} </el-form-item>
      <el-form-item label="已选订单:"> {{ item.list.length }}个 </el-form-item>
      <el-form-item
        required=""
        label="订单标记:"
        prop="orderFlag">
        <el-radio-group v-model="item.orderFlag">
          <el-radio-button :label="1">正常</el-radio-button>
          <el-radio-button :label="2">拍A发B</el-radio-button>
          <el-radio-button :label="3">刷单</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="出库方式:"
        prop="outType">
        <el-radio-group
          v-model="item.outType"
          :disabled="item.disabled">
          <el-radio-button :label="1">正常出库</el-radio-button>
          <el-radio-button :label="2">空包</el-radio-button>
          <!-- <el-radio-button :label="3">特殊</el-radio-button> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="发货仓库:"
        prop="warehouseNo">
        <el-input
          v-model="item.warehouseName"
          readonly="">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="selectWarehouse(item.departmentId)"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item
        label="物流方式:"
        prop="transType">
        <el-radio-group v-model="item.transType">
          <el-radio-button :label="1">陆运</el-radio-button>
          <el-radio-button :label="2">空运</el-radio-button>
          <el-radio-button :label="3">自提</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="销售人员:"
        prop="saleUserIds">
        <department-staff-select v-model="item.saleUserIds" />
      </el-form-item>
      <template v-if="item.transType !== 3">
        <el-form-item
          label="物流模板:"
          prop="logisticsCode">
          <ent-logistics-select
            v-model="item.logisticsCode"
            :callback="logisticsSelectCallback"
            :option="{vendorId: userInfo.orgId}" />
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip
              effect="dark"
              content="根据物流模板信息获取">
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span>发件人:</span>
          </div>
          {{ item.senderName }}-{{ item.senderMobile }}-{{ item.senderProvince }}{{ item.senderCity }}{{ item.senderDistrict }}{{ item.senderAddress }}
        </el-form-item>
      </template>
    </el-form>

    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">提交</el-button>
    </div>
    <warehouse-select-modal
      ref="warehouse"
      :callback="warehouseCallback" />
  </el-dialog>
</template>
<script>
import WarehouseSelectModal from './warehouse-select-modal.vue'
import EntLogisticsSelect from '../../../components/business/ent-logistics-select.vue'
import { mapState } from 'vuex'
import DepartmentStaffSelect from '../../../components/department-staff-select.vue'

// import VendorTagSelect from '../../../components/business/vendor-tag-select.vue'
export default {
  name: 'OrderAuditModalNew',
  components: { WarehouseSelectModal, EntLogisticsSelect, DepartmentStaffSelect },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      active: 0,
      orderList: [],
      orderInfo: {
        warehouseList: []
      },
      visible: false,
      rules: {
        outType: [{ required: true, message: '请选择订单标记', trigger: 'change' }],
        transType: [{ required: true, message: '请选择发货方式', trigger: 'change' }],
        warehouseNo: [{ required: true, message: '请选择发货仓库', trigger: 'change' }],
        logisticsCode: [{ required: true, message: '请选择物流模板', trigger: 'change' }],
        saleUserIds: [{ required: true, message: '请选择销售人员', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      warehouse: state => state.account.warehouse
    }),
    item({ active, orderInfo }) {
      const warehouseList = orderInfo.warehouseList
      return warehouseList[active] || { list: [] }
    }
  },
  watch: {
    orderList: {
      handler(val) {
        const obj = {}
        val.forEach(i => {
          console.log(i)
          const departmentId = i.ownerCode
          if (!obj[departmentId]) {
            obj[departmentId] = []
          }
          obj[departmentId].push(i.id)
        })
        this.orderInfo.warehouseList = Object.keys(obj).map(i => {
          const warehouseNo = localStorage.getItem('sh_default_warehouse') || null
          const logistics = JSON.parse(localStorage.getItem('sh_default_logistics') || '{}')
          return {
            departmentId: i,
            list: obj[i],
            orderFlag: 1,
            outType: 1,
            disabled: true,
            transType: 1,
            logisticsCode: null,
            ...logistics,
            warehouseNo: warehouseNo,
            warehouseName: (this.warehouse.find(i => i.warehouseNo === warehouseNo) || {}).warehouseName,
            saleUserIds: null
          }
        })
      },
      deep: true,
      immediate: true
    },
    'item.orderFlag': {
      handler(val) {
        if (val === 1 || val === 2) {
          this.item.outType = 1
          this.item.disabled = true
        }
        if (val === 3) {
          this.item.disabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.callback && this.callback()
      this.orderList = []
      this.active = 0
      this.orderInfo.warehouseList = []
    },
    logisticsSelectCallback(row) {
      const item = this.orderInfo.warehouseList[this.active]
      this.$set(this.orderInfo.warehouseList, this.active, {
        ...item,
        senderName: row.senderName,
        senderProvince: row.senderProvinceName,
        senderCity: row.senderCityName,
        senderDistrict: row.senderAreaName,
        senderAddress: row.senderAddress,
        senderMobile: row.senderPhone
      })
      localStorage.setItem('sh_default_logistics', JSON.stringify({
        logisticsCode: row.expressId,
        senderName: row.senderName,
        senderProvince: row.senderProvinceName,
        senderCity: row.senderCityName,
        senderDistrict: row.senderAreaName,
        senderAddress: row.senderAddress,
        senderMobile: row.senderPhone
      }))
    },
    add() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const item = this.orderInfo.warehouseList[this.active]
          const saleUserIds = item.saleUserIds || []
          this.$store.dispatch('outstock/salesbatchaudit', {
            payload: {
              logisticsCode: item.transType === 3 ? '00' : item.logisticsCode,
              orderFlag: item.orderFlag,
              transType: item.transType,
              outType: item.outType,
              salesOrderIdList: item.list,
              senderAddress: item.transType === 3 ? '无' : item.senderAddress,
              senderCity: item.transType === 3 ? '无' : item.senderCity,
              senderDistrict: item.transType === 3 ? '无' : item.senderDistrict,
              senderMobile: item.transType === 3 ? '无' : item.senderMobile,
              senderName: item.transType === 3 ? '无' : item.senderName,
              senderProvince: item.transType === 3 ? '无' : item.senderProvince,
              senderTel: item.transType === 3 ? '无' : item.senderTel,
              warehouseNo: item.warehouseNo,
              saleDepartmentNumber: saleUserIds[0] || null,
              saleStaffNumber: saleUserIds[1] || null
            },
            success: () => {
              this.loading = false
              const length = this.orderInfo.warehouseList.length
              if (this.active === length - 1) {
                this.toggleModal(false)
                this.callback && this.callback()
              } else {
                this.active++
              }
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    selectWarehouse(departmentId) {
      this.$refs.warehouse.fetch({
        departmentId,
        productType: 1,
        useType: 1
      })
    },
    warehouseCallback(row) {
      const item = this.orderInfo.warehouseList[this.active]
      this.$set(this.orderInfo.warehouseList, this.active, {
        ...item,
        warehouseNo: row.warehouseNo,
        warehouseName: row.warehouseName
      })
      localStorage.setItem('sh_default_warehouse', row.warehouseNo)
    },
    fetch(orderList) {
      this.orderList = orderList
      this.$set(this, 'orderList', orderList)
      this.toggleModal(true)
    }
  }
}
</script>
